import { VideocamOffOutlined, VideocamOutlined } from '@mui/icons-material';
import { ControlButton, ControlButtonProps } from './ControlButton.component';

export type VideoControlButtonProps = Pick<ControlButtonProps, 'isActive' | 'onToggleActive'>;


export const VideoControlButtonn: React.VFC<VideoControlButtonProps> = props => {

  return (
    <ControlButton
      enabled={{
        icon: <VideocamOutlined />,
        tooltipTitle: 'Video Off'
      }}
      disabled={{
        icon: <VideocamOffOutlined />,
        tooltipTitle: 'Video On'
      }}
      {...props}
    />
  );
};
